import React from 'react';
import { ATextInteractiveSize } from '../../atoms/ATextInteractive/ATextInteractive.types';
import { MRateTitle } from '../MRateTitle/index';
import { MRate } from '../MRate/index';
import { ATextInteractive } from '../../atoms/ATextInteractive/index';
import { MRateBlockCashProps } from './MRateBlockCash.types';
import Styled from './MRateBlockCash.styles';

const COMPONENT_NAME = 'm-web-ui-kit-MRateBlockCash';
const TEST_ID = 'web-ui-kit-MRateBlockCash';

export const MRateBlockCash: React.FC<MRateBlockCashProps> = ({
  mRateTitle,
  mRate,
  aTextInteractive,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      {mRateTitle && <MRateTitle {...mRateTitle} />}
      {mRate && <MRate {...mRate} />}
      {aTextInteractive && <ATextInteractive size={ATextInteractiveSize.XS} {...aTextInteractive} />}
    </Styled.Wrapper>
  );
};

export { TEST_ID as M_RATE_BLOCK_CASH_TEST_ID };
